import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import SmartBanner from './components/SmartBanner';
import HomePage from './components/pages/HomePage';
import LegalPage from './components/pages/LegalPage';
import About from './components/pages/About';
import SharePage from './components/pages/SharePage';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Track page views for analytics (optional)
    // You can add analytics tracking here
    console.log('Page viewed:', location.pathname);
  }, [location]);

  return (
    <div className="App">
      <SmartBanner currentPath={location.pathname} />
      <Navigation />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/about" element={<About />} />
          {/* Community invite link - URL param is 'recipeId' for backwards compatibility */}
          <Route path="/share/:recipeId" element={<SharePage />} />
          {/* Individual recipe share link */}
          <Route path="/recipe/:recipeId" element={<SharePage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
